<template>
  <vx-card>
    <div class="flex justify-between items-center">
      <p style="font-size: 18px; font-weight: 700">옹벽</p>
      <div class="flex justify-end">
        <vs-button class="ml-4" color="secondary" type="border" @click.stop.prevent="onClickDownloadExcel">엑셀(FMS) 내려받기</vs-button>
        <vs-button v-if="isEditable && !!fieldId" class="ml-4" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
        <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
        <vs-button v-if="isEditable" class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
      </div>
    </div>

    <!-- 기본정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>관리주체</div>
          <ml-input readonly v-model="form.management_entity" />
        </div>
        <div>
          <div>소유자</div>
          <ml-input readonly v-model="form.owner" />
        </div>
        <div>
          <div>전화번호</div>
          <ml-input v-model="form.phoneNumber" :readonly="readonly" />
        </div>
        <div>
          <div>보관자</div>
          <ml-input v-model="form.custodian" :readonly="readonly" />
        </div>
        <div>
          <div>관리방법</div>
          <vs-select autocomplete v-model="form.관리방법">
            <vs-select-item text="직접관리" value="직접관리" />
            <vs-select-item text="위탁관리" value="위탁관리" />
          </vs-select>
        </div>
        <div>
          <div>소관부서</div>
          <ml-input v-model="form.소관부서" :readonly="readonly" />
        </div>
        <div>
          <div>담당주무관</div>
          <ml-input v-model="form.담당주무관" :readonly="readonly" />
        </div>
      </div>
    </div>

    <!-- 시설물 정보 -->
    <RetainingWallWriteBody :form="form" :category-info="categoryInfo" :readonly="readonly" />

    <!-- 관리 부서 및 업체 등록 -->
    <company-add-module
      title="관리 부서 및 업체 등록"
      :tableColumns="[
        { head: '구분', key: 'com_type' },
        { head: '부서(업체)명', key: 'com_name' },
        { head: '연락처', key: 'phone' },
      ]"
      :isSimple="true"
      :readonly="readonly"
      v-model="companyList"
      @remove="removeCompany"
    />

    <!-- 전경사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진" placeholder="전경사진" :readonly="readonly" />

    <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field" />
  </vx-card>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import RetainingWallWriteBody from "@/views/fields/single-page/retaining-wall/RetainingWallWriteBody.vue";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
import PortWriteBody from "@/views/fields/single-page/port-dock/PortWriteBody.vue";
import ExcelJS from "exceljs";

export default {
  components: {
    PortWriteBody,
    FileUploadModule,
    RetainingWallWriteBody,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당주무관: "",

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: "",
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: "",
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: "",
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: "",
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate: "",
        constructionSupervisor: "",
        creationDate: moment().format("YYYY-MM-DD"),
        author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        옹벽단수: 0,
        위치좌표시점: "",
        위치좌표종점: "",

        옹벽분류: [],
        옹벽제원: [],

        otherSpecifications: "",

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },

      cat1List: [],
      cat2List: [],
      cat3List: [],
      cat4List: [],
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      return !!projectInfo.field_edit_by_manager_only;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", {project_id: this.projectId});
  },
  async mounted() {
    await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", {});

    const _cat1List = this.$store.state.project.fieldFacilityCategoryOptions.map((item) => item.cat1);
    this.cat1List = this.setCatOther(_cat1List);

    if (this.fieldId) {
      await this.loadField();
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = { ...this.form, ...info, ...JSON.parse(info.meta) };

      if (this.form.facility_category) {
        this.cat1 = this.form.facility_category.cat1;
        this.cat2 = this.form.facility_category.cat2;
        this.cat3 = this.form.facility_category.cat3;
        this.cat4 = this.form.facility_category.id;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      // 2024-03-06 : 키 값이 잘못 설정된 상태로 저장된 데이터가 있어서, 잘못된 키 값을 수정
      // 내용 : this.form.옹벽제원 값 중에 "단면형태별평면선형" 데이터가 있을 경우, 키 이름을 "옹벽전면부"로 변경
      if (this.form.옹벽제원) {
        for (const item of this.form.옹벽제원) {
          if (item.단면형태별평면선형) {
            item.옹벽전면부 = item.단면형태별평면선형;
            delete item.단면형태별평면선형;
          }
        }
      }


      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];
      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    // ==================================================
    // ==================== Category ====================
    // ==================================================
    async onChangeCat1(data) {
      if (data && !this.catLock) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: data });
        const _cat2List = this.$store.state.project.fieldFacilityCategoryOptions.map((item) => item.cat2);
        this.cat2List = this.setCatOther(_cat2List);
        this.cat2 = "";
        this.cat3 = "";
        this.cat4 = "";
      }
    },
    async onChangeCat2(data) {
      if (data && !this.catLock) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.cat1, cat2: data });
        const _cat3List = this.$store.state.project.fieldFacilityCategoryOptions.map((item) => item.cat3);
        this.cat3List = this.setCatOther(_cat3List);
        this.cat3 = "";
        this.cat4 = "";
      }
    },
    async onChangeCat3(data) {
      if (data && !this.catLock) {
        await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_OPTIONS", { cat1: this.cat1, cat2: this.cat2, cat3: data });
        this.cat4List = this.$store.state.project.fieldFacilityCategoryOptions;
        this.cat4 = "";
      }
    },
    onChangeCat4(data) {
      if (!this.catLock) this.form.facility_category_id = data;
    },

    // 정렬 후 기타, 기타 외를 배열의 마지막으로 이동하는 함수
    setCatOther(list) {
      list.sort();

      const etcIndex = list.indexOf("기타");
      if (etcIndex > -1) {
        list.splice(etcIndex, 1);
        list.push("기타");
      }
      const etcOutIndex = list.indexOf("기타 외");
      if (etcOutIndex > -1) {
        list.splice(etcOutIndex, 1);
        list.push("기타 외");
      }

      return list;
    },

    // ==================================================
    // ==================================================

    // 옹벽단수의 수만큼 옹벽분류,옹벽제원의 배열이 생성된다
    change옹벽단수() {
      const 옹벽단수 = this.form.옹벽단수;
      const 옹벽분류 = this.form.옹벽분류;
      const 옹벽제원 = this.form.옹벽제원;

      if (옹벽단수 > 옹벽분류.length) {
        for (let i = 옹벽분류.length; i < 옹벽단수; i++) {
          옹벽분류.push({
            단: i + 1,
            형식별: "",
            재료별: "",
            평면선형: "",
            횡단선형: "",
          });
          옹벽제원.push({
            단: i + 1,
            옹벽전면부: {
              연장: "",
              높이: "",
              두께상단: "",
              두께하단: "",
            },
            옹벽저판부앞굽판: {
              가로: "",
              세로: "",
              두께앞: "",
              두께뒤: "",
            },
            옹벽저판부뒷굽판: {
              가로: "",
              세로: "",
              두께앞: "",
              두께뒤: "",
            },
            매립깊이: "",
            사면구배: "",
            인접보호시설물현황: {
              시설물명: "",
              규모: "",
            },
            이격거리: {
              내이격거리: "",
              외이격거리: "",
            },
            배수공: {
              지름크기: "",
              개수: "",
            },
            앵커유무: {
              유무: "",
              개수: "",
            },
            시공이음부유무: {
              유무: "",
              개수: "",
            },
          });
        }
      } else if (옹벽단수 < 옹벽분류.length) {
        옹벽분류.splice(옹벽단수, 옹벽분류.length - 옹벽단수);
        옹벽제원.splice(옹벽단수, 옹벽제원.length - 옹벽단수);
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickSave() {
      // 필수 : facilityName,
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.cat4, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      const user_ids = [];
      if (this.joinUsers.length > 0) {
        for (const user of this.joinUsers) {
          user_ids.push(user.id);
        }
      }
      option.company_ids = company_ids;
      option.user_ids = user_ids;

      // Meta
      option.meta = { ...this.form, lastModifiedDate: moment().format("YYYY-MM-DD"), lastModifiedBy: this.myInfo.name };

      this.$emit("save", option);
    },
    onClickDelete() {
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch('/fms/시설물관리대장_옹벽.xlsx');
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      this.applyDataToSheet(worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      let fileName = '';
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장`;
      }
      fileName += '.xlsx';

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    applyDataToSheet(worksheet) {
      const cellMatchInfo = {
        facilityNumber: ['Y4', 'B20'],  // 시설물번호
        managementNumber: ['Y5', 'K20'], // 관리번호
        facilityName: ['Y6', 'P20', 'B41'], // 시설물명
        management_entity: ['W13', 'T22'], // 관리주체
        owner: ['W14'], // 소유자
        custodian: ['W15'], // 보관자
        routeDivision: ['AA20'], // 노선-구분
        routeDetail: ['AF20'], // 노선-세부노선
        cat1: ['AX20'], // 시설물구분
        cat3: ['AM20'], // 시설물종류
        classification: ['AR20'],  // 시설물종별
        socEvaluationTarget: ['BF20'], // SOC성능평가대상
        address: ['B22'], // 주소
        businessPlanApprovalDate: ['B27'], // 사업계획승인일
        completionDate: ['G27'], // 준공일
        defectLiabilityExpirationDate1: ['O27'], // 하자보수보증종료일
        detailedSpecifications: ['V27'], // 상세제원
        safetyInspectionAndDiagnosisHistory: ['Z27'], // 안전점검진단이력
        repairAndReinforcementHistory: ['AH27'], // 보수보강이력
        accessibleVentCover: ['AO27'], // 통풍구방법
        designer: ['R29'], // 설계자
        contractor: ['AN29'], // 시공자
        totalConstructionCost: ['BA29'], // 총공사비
        seismicDesignTarget: ['F31'], // 지진설계대상
        seismicDesignApplication: ['R31'], // 지진설계적용
        seismicDesignStandard: ['AB31'], // 지진설계기준
        seismicPerformanceEvaluation: ['AN31'], // 지진성능평가
        seismicReinforcement: ['BA31'], // 지진보강
        young21Target: ['B33'], // 영21조대상
        auditor: ['R33'], // 감리자
        projectOwner: ['AB33'], // 사업주체
        constructionName: ['AN33'], // 공사명
        constructionSupervisor: ['BA33'], // 공사감독
        creationDate: ['B36'], // 작성일
        lastModifiedDate: ['AC36'], // 최종 수정일
        lastModifiedBy: ['AS36'], // 최종 수정자
        remarks: ['E37'], // 비고

        // 상세제원
        옹벽단수: ['R41'], // 옹벽단수
        위치좌표시점: ['AJ41'], // 위치좌표시점
        위치좌표종점: ['AW41'], // 위치좌표종점
      };


      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : '';
        }
      }


      worksheet.getCell('Z25').value = '';
      worksheet.getCell('AD25').value = '';
      worksheet.getCell('AI25').value = '';
      worksheet.getCell('AM23').value = '';
      if (this.form.management_type === '중앙부처') {
        worksheet.getCell('Z25').value = 'V';
      } else if (this.form.management_type === '지자체') {
        worksheet.getCell('AD25').value = 'V';
      } else if (this.form.management_type === '(국가/지방)공기업') {
        worksheet.getCell('AI25').value = 'V';
      } else if (this.form.management_type === '민간') {
        worksheet.getCell('AM23').value = 'V';
      }

      worksheet.getCell('AU25').value = '';
      worksheet.getCell('BB25').value = '';
      worksheet.getCell('BE25').value = '';
      worksheet.getCell('BG23').value = '';
      if (this.form.ownerType === '중앙부처') {
        worksheet.getCell('AU25').value = 'V';
      } else if (this.form.ownerType === '지자체') {
        worksheet.getCell('BB25').value = 'V';
      } else if (this.form.ownerType === '(국가/지방)공기업') {
        worksheet.getCell('BE25').value = 'V';
      } else if (this.form.ownerType === '민간') {
        worksheet.getCell('BG23').value = 'V';
      }

      // 전화번호
      worksheet.getCell('AK14').value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록
      const fileNames = this.fileList.map((file) => file.originalName).join(', ');
      worksheet.getCell('AV27').value = fileNames;

      // 설계기간
      worksheet.getCell('B29').value = `${this.form.designPeriod.sDate  } ~ ${  this.form.designPeriod.eDate}`;

      // 공시기간
      worksheet.getCell('AB29').value = `${this.form.constructionPeriod.sDate  } ~ ${  this.form.constructionPeriod.eDate}`;

      // 감리기간
      worksheet.getCell('F33').value = `${this.form.auditPeriod.sDate  } ~ ${  this.form.auditPeriod.eDate}`;

      // 작성자
      worksheet.getCell('M36').value = `${this.form.author }  (인)`;


      // 빈칸으로 만들 칸들
      const emptyCells = ['D22', 'H22', 'N22', 'N24'];
      for (const cell of emptyCells) {
        worksheet.getCell(cell).value = '';
        console.log(worksheet.getCell(cell))
      }

      const merges = worksheet.model.merges.slice();
      console.log({merges})

      // 상세제원, 단수에 따라서 칸을 삽입해야 함 ------
      const 옹벽단수 = parseInt(this.form.옹벽단수 || '0');
      // 삽입해야 하는 줄의 수
      const insertCount = 옹벽단수 - 1;
      if (옹벽단수 > 1) {
        // insertCount 개수 만큼의 빈 배열을 삽입
        const emptyRows = Array(insertCount).fill([]);
        // 옹벽분류
        let startRow = 46;
        worksheet.insertRows(startRow, emptyRows, 'i+');
        this.adjustMergedCellsAfterInsert(worksheet, startRow, insertCount);
        for (let i = 0; i < insertCount; i++) {
          worksheet.mergeCells(`C${startRow + i}:W${startRow + i}`);
          worksheet.mergeCells(`X${startRow + i}:AF${startRow + i}`);
          worksheet.mergeCells(`AG${startRow + i}:AP${startRow + i}`);
          worksheet.mergeCells(`AQ${startRow + i}:BB${startRow + i}`);
          worksheet.mergeCells(`BC${startRow + i}:BG${startRow + i}`);
        }

        // 옹벽제원 1번째
        startRow = 52 + insertCount;
        worksheet.insertRows(startRow, emptyRows, 'i+');
        this.adjustMergedCellsAfterInsert(worksheet, startRow, insertCount);
        for (let i = 0; i < insertCount; i++) {
          const targetRow = startRow + i;
          worksheet.mergeCells(`C${targetRow}:H${targetRow}`); // 옹벽전면부_연장
          worksheet.mergeCells(`I${targetRow}:K${targetRow}`); // 옹벽전면부_높이
          worksheet.mergeCells(`L${targetRow}:P${targetRow}`); // 옹벽전면부_두께상단
          worksheet.mergeCells(`Q${targetRow}:T${targetRow}`); // 옹벽전면부_두께하단

          worksheet.mergeCells(`U${targetRow}:X${targetRow}`); // 옹벽저판부앞굽판_가로
          worksheet.mergeCells(`Y${targetRow}:AA${targetRow}`); // 옹벽저판부앞굽판_세로
          worksheet.mergeCells(`AB${targetRow}:AF${targetRow}`); // 옹벽저판부앞굽판_두께앞
          worksheet.mergeCells(`AG${targetRow}:AK${targetRow}`); // 옹벽저판부앞굽판_두께뒤

          worksheet.mergeCells(`AL${targetRow}:AO${targetRow}`); // 옹벽저판부뒷굽판_가로
          worksheet.mergeCells(`AP${targetRow}:AS${targetRow}`); // 옹벽저판부뒷굽판_세로
          worksheet.mergeCells(`AT${targetRow}:AX${targetRow}`); // 옹벽저판부뒷굽판_두께앞
          worksheet.mergeCells(`AY${targetRow}:BC${targetRow}`); // 옹벽저판부뒷굽판_두께뒤
          worksheet.mergeCells(`BD${targetRow}:BF${targetRow}`); // 매립깊이
        }

        // 옹벽제원 2번째
        startRow = 55 + (insertCount * 2);
        worksheet.insertRows(startRow, emptyRows, 'i+');
        this.adjustMergedCellsAfterInsert(worksheet, startRow, insertCount);
        for (let i = 0; i < insertCount; i++) {
          const targetRow = startRow + i;
          worksheet.mergeCells(`C${targetRow}:R${targetRow}`);
          worksheet.mergeCells(`S${targetRow}:AF${targetRow}`);
          worksheet.mergeCells(`AG${targetRow}:AT${targetRow}`);
          worksheet.mergeCells(`AU${targetRow}:BG${targetRow}`);
        }

        // // 옹벽제원 3번째
        startRow = 58 + (insertCount * 3);
        worksheet.insertRows(startRow, emptyRows, 'i+');
        this.adjustMergedCellsAfterInsert(worksheet, startRow, insertCount);
        for (let i = 0; i < insertCount; i++) {
          const targetRow = startRow + i;
          worksheet.mergeCells(`C${targetRow}:M${targetRow}`);
          worksheet.mergeCells(`N${targetRow}:W${targetRow}`);
          worksheet.mergeCells(`X${targetRow}:AF${targetRow}`);
          worksheet.mergeCells(`AG${targetRow}:AP${targetRow}`);
          worksheet.mergeCells(`AQ${targetRow}:BB${targetRow}`);
          worksheet.mergeCells(`BC${targetRow}:BG${targetRow}`);
        }
      }

      for (let i = 0; i < 옹벽단수; i++) {
        const 옹벽분류 = this.form.옹벽분류[i];
        const 옹벽제원 = this.form.옹벽제원[i];

        // 1번째 줄
        let startRowNum = 45;
        if (i > 0) {
          worksheet.getCell(`B${startRowNum + i}`).value = `${i + 1}단`;
        }
        worksheet.getCell(`C${startRowNum + i}`).value = 옹벽분류.형식별;
        worksheet.getCell(`X${startRowNum + i}`).value = 옹벽분류.재료별;
        worksheet.getCell(`AG${startRowNum + i}`).value = 옹벽분류.평면선형;
        worksheet.getCell(`AQ${startRowNum + i}`).value = 옹벽분류.종단선형;
        worksheet.getCell(`BC${startRowNum + i}`).value = 옹벽분류.횡단선형;

        // 2번째 줄
        startRowNum = 51 + insertCount;
        if (i > 0) {
          worksheet.getCell(`B${startRowNum + i}`).value = `${i + 1}단`;
        }
        worksheet.getCell(`C${startRowNum + i}`).value = 옹벽제원.옹벽전면부.연장;
        worksheet.getCell(`I${startRowNum + i}`).value = 옹벽제원.옹벽전면부.높이;
        worksheet.getCell(`L${startRowNum + i}`).value = 옹벽제원.옹벽전면부.두께상단;
        worksheet.getCell(`Q${startRowNum + i}`).value = 옹벽제원.옹벽전면부.두께하단;

        worksheet.getCell(`U${startRowNum + i}`).value = 옹벽제원.옹벽저판부앞굽판.가로;
        worksheet.getCell(`Y${startRowNum + i}`).value = 옹벽제원.옹벽저판부앞굽판.세로;
        worksheet.getCell(`AB${startRowNum + i}`).value = 옹벽제원.옹벽저판부앞굽판.두께앞;
        worksheet.getCell(`AG${startRowNum + i}`).value = 옹벽제원.옹벽저판부앞굽판.두께뒤;

        worksheet.getCell(`AL${startRowNum + i}`).value = 옹벽제원.옹벽저판부뒷굽판.가로;
        worksheet.getCell(`AP${startRowNum + i}`).value = 옹벽제원.옹벽저판부뒷굽판.세로;
        worksheet.getCell(`AT${startRowNum + i}`).value = 옹벽제원.옹벽저판부뒷굽판.두께앞;
        worksheet.getCell(`AY${startRowNum + i}`).value = 옹벽제원.옹벽저판부뒷굽판.두께뒤;

        worksheet.getCell(`BD${startRowNum + i}`).value = 옹벽제원.매립깊이;
        worksheet.getCell(`BG${startRowNum + i}`).value = 옹벽제원.사면구배;

        // 3번째 줄
        startRowNum = 54 + (insertCount * 2);
        if (i > 0) {
          worksheet.getCell(`B${startRowNum + i}`).value = `${i + 1}단`;
        }
        worksheet.getCell(`C${startRowNum + i}`).value = 옹벽제원.인접보호시설물현황.시설물명;
        worksheet.getCell(`S${startRowNum + i}`).value = 옹벽제원.인접보호시설물현황.규모;

        worksheet.getCell(`AG${startRowNum + i}`).value = 옹벽제원.이격거리.내이격거리;
        worksheet.getCell(`AU${startRowNum + i}`).value = 옹벽제원.이격거리.외이격거리;

        // 4번째 줄
        startRowNum = 57 + (insertCount * 3);
        if (i > 0) {
          worksheet.getCell(`B${startRowNum + i}`).value = `${i + 1}단`;
        }
        worksheet.getCell(`C${startRowNum + i}`).value = 옹벽제원.배수공.지름크기;
        worksheet.getCell(`N${startRowNum + i}`).value = 옹벽제원.배수공.개수;

        worksheet.getCell(`X${startRowNum + i}`).value = 옹벽제원.앵커유무.유무;
        worksheet.getCell(`AG${startRowNum + i}`).value = 옹벽제원.앵커유무.개수;

        worksheet.getCell(`AQ${startRowNum + i}`).value = 옹벽제원.시공이음부유무.유무;
        worksheet.getCell(`BC${startRowNum + i}`).value = 옹벽제원.시공이음부유무.개수;
      }

      // 기타 상세제원
      worksheet.getCell(`Q${58 + (insertCount * 4)}`).value = this.form.otherSpecifications;
    },
    /**
     * 행을 삽입하더라도, 병합된 셀의 정보는 !!업데이트되지 않기 때문에!!
     * 삽입된 행 이후의 행들에 적용된 병합 정보가 올바르지 않게 되는 문제(모든 병합이 깨짐)가 발생한다.
     * 이를 방지하기 위하여, 삽입된 행 부터 이후의 모든 병합 정보를 제거한 뒤에
     * 삽입된 행 개수 만큼 병합 정보를 뒤로 이동시킨 새로운 병합 정보를 삽입시킨다.
     *
     * @param worksheet 대상 시트
     * @param insertAt 삽입된 행의 위치(번호)
     * @param numRows 삽입된 행의 개수
     */
    adjustMergedCellsAfterInsert(worksheet, insertAt, numRows) {
      // 병합된 셀 범위를 복사하여 새 배열에 저장 (직접 수정을 피하기 위해)
      const newMerges = worksheet.model.merges.slice();
      // 병합을 해제한 뒤에 새로운 병합 범위를 저장할 배열
      const mergeCells = [];

      // 병합된 셀 범위를 조정
      newMerges.forEach((merge) => {
        const [startCell, endCell] = merge.split(':');
        const start = worksheet.getCell(startCell);
        const end = worksheet.getCell(endCell);

        let newStartRow = -1;
        let newEndRow = -1;

        if (start.row >= insertAt) {
          newStartRow = start.row + numRows;
        }
        if (end.row >= insertAt) {
          newEndRow = end.row + numRows;
        }

        // 삽입된 행 범위에 영향을 받는 경우, 병합 범위를 조정
        if (newStartRow !== -1 || newEndRow !== -1) {
          const newStart = newStartRow < 0 ? start : worksheet.getCell(newStartRow, start.col);
          const newEnd = newEndRow < 0 ? end : worksheet.getCell(newEndRow, end.col);
          worksheet.unMergeCells(merge); // 기존 병합 해제
          mergeCells.push(`${newStart.address}:${newEnd.address}`);
        }
      });

      // 조정된 병합 범위를 적용
      mergeCells.forEach(merge => {
        worksheet.mergeCells(merge);
      });
    }
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
